module.exports = __webpack_public_path__ + "img/8.cae498b2.jpg";